import { IRoute } from "../interfaces/IRoute";

// Screens
import Home from "../screens/Home";
import NotFound from "../screens/NotFound";
import Configurations from "../screens/Configurations";
import CreateExpense from "../screens/CreateExpense";

const privateRoutes: IRoute[] = [
    {
        component: Home,
        path: "/app",
        exact: true,
    },
    {
        component: Configurations,
        path: "/app/configuracoes",
        exact: true,
    },
    {
        component: CreateExpense,
        path: "/app/gasto/adicionar",
        exact: true,
    },
    {
        component: CreateExpense,
        path: "/app/gasto/:uuid",
        exact: true,
    },
    {
        component: NotFound,
        path: "*",
    },
];

export default privateRoutes;
